import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTranslate, Button as RaButton } from 'react-admin';
import {
  Checkbox as MuiCheckbox,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
  DialogTitle as MuiDialogTitle,
  FormControlLabel as MuiFormControlLabel,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ContractSignatureConsentModalProps } from './types';

const useStyles = makeStyles({
  content: {
    whiteSpace: 'pre-wrap',
  },
  actions: {
    justifyContent: 'center',
    marginBottom: '16px',
  },
});

/**
 * The contract signatory admin's consent to the automatic signature of the
 * contracts they launch in "Automatique" mode: the consent text (its
 * version is ContractSignatureConsent::TEXT_VERSION in the API), a checkbox
 * and "Je consens", enabled once checked.
 */
const ContractSignatureConsentModal: FunctionComponent<ContractSignatureConsentModalProps> =
  (props) => {
    const t = useTranslate();
    const classes = useStyles();
    const { open, firstName, lastName, loading, handleClose, handleConsent } =
      props;
    const [accepted, setAccepted] = useState(false);

    useEffect(() => {
      if (open) setAccepted(false);
    }, [open]);

    return (
      <MuiDialog open={open} onClose={handleClose} maxWidth="md">
        <MuiDialogTitle>{t('resource.contracts.consent.title')}</MuiDialogTitle>
        <MuiDialogContent>
          <MuiDialogContentText className={classes.content}>
            {t('resource.contracts.consent.text', {
              first_name: firstName,
              last_name: lastName,
            })}
          </MuiDialogContentText>
          <MuiFormControlLabel
            control={
              <MuiCheckbox
                color="primary"
                checked={accepted}
                onChange={(event) => setAccepted(event.target.checked)}
              />
            }
            label={t('resource.contracts.consent.checkbox')}
          />
        </MuiDialogContent>
        <MuiDialogActions className={classes.actions}>
          <RaButton
            onClick={handleClose}
            variant="text"
            color="primary"
            label={t('modal.confirm.cancel')}
          />
          <RaButton
            onClick={handleConsent}
            variant="contained"
            color="primary"
            disabled={!accepted || loading}
            label={t('resource.contracts.consent.confirm')}
          />
        </MuiDialogActions>
      </MuiDialog>
    );
  };

export default ContractSignatureConsentModal;
